import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useDialogContext } from '../context';
import * as authActions from '../store/actions/authActions';

const useStyles = makeStyles((theme) => ({
  description: {
    marginBottom: theme.spacing(3),
    maxWidth: 420,
  },
  button: {
    marginBottom: theme.spacing(1.5),
  },
}));

const FacebookMigrationConfirmDialog = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { dialogDispatch } = useDialogContext();
  const { t } = useTranslation();
  const isLoading = useSelector((state) => state.auth.isLoading);
  const errorMessage = useSelector((state) => state.auth.errorMessage);

  const handleContinue = () => {
    dispatch(authActions.startFacebookMigration());
  };

  const handleCancel = () => {
    dispatch(authActions.cancelFacebookMigration());
    dialogDispatch({ type: 'OPEN_AS', payload: 'login' });
  };

  return (
    <div>
      <Typography className={classes.description}>
        {t('facebookMigration.confirmDescription')}
      </Typography>
      {errorMessage ? (
        <Typography color="error" role="alert" className={classes.description}>
          {errorMessage}
        </Typography>
      ) : null}
      <Button
        className={classes.button}
        color="primary"
        variant="contained"
        size="large"
        fullWidth
        disabled={isLoading}
        onClick={handleContinue}
      >
        {t('facebookMigration.continueAccountMigration')}
      </Button>
      <Button
        size="large"
        fullWidth
        disabled={isLoading}
        onClick={handleCancel}
      >
        {t('messages.cancel')}
      </Button>
    </div>
  );
};

export default FacebookMigrationConfirmDialog;
